import request from '../utils/request'
export default {
	/*-------------------------------------------------------------通用 start-----------------------------------------------------------  */
    //人事-人员-人员调整查看- 李旭
    checkPersonInfo({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/turnover/query`,
			data: params
		})
	},
	// 人事-人员-人员调整填报 - 李旭
	changePersonInfo({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/turnover/save`,
			data: params
		})
	},
	// 人事-人员-人员调整详情 - 李旭
	personDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/turnover/detail`,
			data: params
		})
	},
	// 人事-人员-人员调整删除 - 李旭
	delPerson({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/turnover/delete`,
			data: params
		})
	},
	// 人事-人员-人员调整发布 - 李旭
	releasePerson({ ...params }) {
		console.log("params",params);
		return request({
			method: 'GET',
			url: `/bpc/personnel/turnover/publish?configurationId=${params.configurationId}`,
			// data: params
		})
	},
	// 族群等级查询
	levelInfo() {
		return request({
			method: 'GET',
			url: `/bpc/system/ethnicGroupLevel/list`,
		})
	},
	
	/*-------------------------------------------------------------v3.0-----------------------------------------------------------  */
	// 是否末级人员
	queryEndPersonnelTurnoverList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/turnover/queryEndPersonnelTurnoverList`,
			data: params
		})
	},
	// 人员查看
	queryPersonnelByTimeData({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/personnel/turnover/queryPersonnelByTimeData`,
			data: params
		})
	},
	/*-------------------------------------------------------------通用 end-----------------------------------------------------------  */
}